export const getDescription = (search: string) => (search.trim()
  ? {
    id: 'step1.existing',
    defaultMessage: 'Or choose an existing position...'
  }
  : {
    id: 'step1.recent',
    defaultMessage: 'My recent positions'
  });
